<sgt-pedido-pedido-list
    #list
    tableId="resultadoCampanhaTable_{{objetivoVenda ? 'venda' : ''}}_{{objetivoBonificacao ? 'bonificacao' : ''}}"
    visualizacaoStorageKey="resultadoCampanhaVendaList_{{objetivoVenda ? 'venda' : ''}}_{{objetivoBonificacao ? 'bonificacao' : ''}}"
    [filter]="pedidoFilter"
    [optionsVisibility]="{
        canEdit: false,
        canConsultar: false,
        canConfirmar: false,
        canExportOneErp: false,
        canEnviarEmail: false,
        canPrint: true,
        canDuplicate: false,
        canLiberar: false,
        canIniciarAguardandoProducao: false,
        canTerminarAguardandoProducao: false,
        canLiberarExpedicao: false,
        canCancelar: false,
        canImportOneEcommerce: false,
        canImportOneErp_v1: false,
        canImportOneErp: false,
        canOpenRetornoAmostras: false,
        canSolicitarRevisao: false,
        canRevisar: false,
        canConfirmarPCP: false,
        canPrintPropostaComercial: false,
        canSendEmailPropostaComercial: false,
        canRetornarAnaliseCliente: false          
    }"
    [columnsVisibility]="{
        options: true,
        badges: true,
        lucroLiquido: true,
        numero: true,
        numeroEcommerce: true,
        numeroERP: true,
        dataEmissao: true,
        dataConfirmacao: true,
        quantidadeTotal: true,
        quantidadeVolumesPrevistos: true,
        valorTotal: true,
        status: true,
        setorGep: true,
        cliente: true,
        classificacaoFaturamentoPretendida: true,
        representante: true,
        motivoReprovado: false,
        tabelaPreco: true,
        campanha: false,
        condicaoPagamento: true,
        motivoNaoLiberado: false,
        dataNaoLiberado: false,
        vendaReferenciada: false,
        lucroLiquidoNaoLiberado: false,
        dataLiberado: true,
        usuarioLiberado: true,
        justificativaLiberado: true
    }">
</sgt-pedido-pedido-list> 